import { Routes } from '@angular/router';
import { CourseComponent } from './course/course.component';
import { CourseManagementComponent } from './course-management/course-management.component';
import { lessonRoutes } from '../lesson/lesson.routes';
import { AuthGuard } from '../../guards/auth.guard';
import { CourseListComponent } from './course-list/course-list.component';

export const coursesRoutes: Routes = [
  {
    path: 'courses',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {}
    },
    children: [
      {
        path: '',
        component: CourseListComponent,
        data: {
          breadcrumb: {
            bcType: 'Display',
            action: 'List',
            value: 'Courses',
            type: 'Course'
          }
        }
      },
      {
        path: 'create',
        component: CourseComponent,
        data: {
          type: 'create',
          breadcrumb: {
            bcType: 'Display',
            action: 'Create',
            value: 'Courses',
            type: 'Course'
          }
        }
      },
      {
        path: ':courseId',
        data: {
          breadcrumb: {
            bcType: 'LookUp',
            value: 'courseId',
            type: 'Course'
          }
        },
        children: [
          {
            path: 'edit',
            component: CourseComponent,
            data: {
              type: 'edit',
              breadcrumb: {
                bcType: 'Display',
                action: 'Edit'
              }
            }
          },
          {
            path: 'manage',
            component: CourseManagementComponent,
            data: {
              breadcrumb: {
                bcType: 'Display',
                action: 'Manage',
              }
            }
          },
          ...lessonRoutes
        ]
      }
    ]
  },
];
